/* src/app/components/fileupload/fileupload.component.css */
.dropControl_wrapper {
  min-width: 245px;
  margin: auto;
}
.template-icons {
  padding-left: 3%;
}
.fileListwrapper {
  height: 65px;
  display: block;
  padding: 2px;
  width: 85%;
}
.bottom-padding {
  padding-bottom: 140px;
}
.dropControl_wrapper .sample_wrapper #dropArea .dropFiles .e-upload .e-upload-files .e-upload-file-list,
.e-bigger .dropControl_wrapper .sample_wrapper #dropArea .dropFiles .e-upload .e-upload-files .e-upload-file-list {
  min-height: 70px;
  border-top: 1px solid #ddd;
}
.e-upload .e-upload-files .e-upload-file-list .e-file-container {
  text-align: left;
}
.dropControl_wrapper .sample_wrapper #dropArea .dropFiles .e-upload {
  width: 100%;
  display: block;
  margin: 20px auto;
  border-top: none;
  border-bottom: none;
}
.dropControl_wrapper .sample_wrapper #dropArea .dropFiles .e-upload .e-upload-files {
  border-top: none;
}
.highcontrast .dropControl_wrapper .sample_wrapper #dropArea #drop a {
  color: #ffd939;
}
#drop a {
  font-size: 14px;
}
.dropControl_wrapper .sample_wrapper #dropArea {
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-top: 25px;
}
.dropControl_wrapper .sample_wrapper #dropArea .e-file-select-wrap {
  display: none;
}
.dropControl_wrapper #fileupload .e-upload .e-file-select-wrap {
  display: none;
}
.dropControl_wrapper #fileupload .e-upload {
  border: none;
}
.dropControl_wrapper #fileupload ul.e-upload-files {
  border: 1px solid #dadada;
}
.dropText {
  color: #757575 !important;
  text-align: center;
}
.dropArea_wrap {
  width: 100%;
  height: auto;
  background-color: #fff;
  display: block;
  border: 2px dashed #666;
  border-radius: 10px;
  margin-top: 30px;
  text-align: center;
  padding-bottom: 0.25em;
}
.highcontrast .dropArea_wrap {
  background-color: #000;
}
.font-icons {
  position: relative;
  text-align: center;
  margin: 10px 0px 10px 60px;
  font-size: 6em;
  color: #757575;
}
.font-icons i {
  margin-right: 20px;
}
.dropArea_wrap i.fa-file-code:after {
  content: ".xml";
  font-family: open_sansregular;
  font-size: 18px;
  position: relative;
  top: 30px;
  right: 55px;
}
.dropArea_wrap i.fa-file-excel:after {
  content: ".xlsx";
  font-family: open_sansregular;
  font-size: 18px;
  position: relative;
  top: 30px;
  right: 55px;
}
.upload-failed {
  color: #E11919;
}
.upload-success {
  color: #29A829;
}
span.upload-status {
  left: 54px;
  position: relative;
  font-size: 12px;
  display: block;
  padding: 5px;
  top: -8px;
}
.e-upload .e-upload-files .e-file-remove-btn.e-icons,
.e-upload .e-upload-files .e-file-delete-btn.e-icons {
  top: 50%;
}
.ul-element {
  list-style: none;
  width: 100%;
  padding-left: 0;
}
span.list-wrapper {
  max-height: 400px;
  display: block;
  margin-left: 10px;
  position: relative;
  top: 2px;
}
.file-name {
  padding: 8px 6px 5px 12px;
  font-size: 13px;
  width: 76%;
  display: inline-block;
  position: relative;
}
.e-bigger .file-name {
  font-size: 14px;
}
.file-size {
  padding: 4px;
  font-size: 13px;
  width: 18%;
  display: inline-block;
  position: relative;
}
.e-bigger .file-size {
  font-size: 14px;
}
.file-lists {
  border: 1px solid lightgray;
  padding: 0 6px 0 14px;
  margin-top: 15px;
  position: relative;
  background: rgba(0, 0, 0, 0.04);
}
.file-size,
.file-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.e-upload-drag-hover {
  border-color: #29A829;
  outline: none;
}
.e-upload-drag-hover:focus {
  border: none;
  outline: none;
}
/*# sourceMappingURL=fileupload.component.css.map */
